import { Box, Divider } from "@mui/material";

import { CustomCard, CustomCardHeader, DividerWrapper } from "./style";

interface ChildCardPropsType {
  children?: React.ReactNode;
  icon?: JSX.Element;
  title: string;
  hideDivider?: boolean;
  isDataTable?: boolean;
  isNotesTable?: boolean;
  disableDividerStyle?: boolean;
  viewMode?: boolean;
}

const ChildCard = (props: ChildCardPropsType) => {
  const {
    children,
    title,
    icon,
    hideDivider = false,
    isDataTable = false,
    isNotesTable = false,
    viewMode = false,
    disableDividerStyle,
  } = props;

  return (
    <CustomCard
      $isDataTable={isDataTable}
      $isNotesTable={isNotesTable}
      $viewMode={viewMode}
    >
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <CustomCardHeader>{title}</CustomCardHeader>
        {icon ? <Box sx={{ margin: "0px 8px" }}>{icon}</Box> : null}
      </Box>
      <DividerWrapper disableDividerStyle={disableDividerStyle}>
        {!hideDivider && <Divider />}
      </DividerWrapper>
      {children}
    </CustomCard>
  );
};

ChildCard.defaultProps = {
  children: undefined,
  icon: "",
  hideDivider: false,
  isDataTable: false,
  disableDividerStyle: false,
};

export default ChildCard;
